import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Switch,
  FormControlLabel,
  Button,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";

const HEADER_HEIGHT = 64;

const Header = ({ darkMode, toggleDarkMode, toggleDrawer }) => {
  const [dateTime, setDateTime] = useState("");
  const [cookieConsent, setCookieConsent] = useState(
    localStorage.getItem("cookieConsent") === "true"
  );
  const theme = useTheme();

  // Update date once a minute
  useEffect(() => {
    const update = () => {
      const now = new Date();
      setDateTime(
        now.toLocaleDateString("en-US", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      );
    };
    update();
    const id = setInterval(update, 60_000);
    return () => clearInterval(id);
  }, []);

  const handleCookieConsent = () => {
    localStorage.setItem("cookieConsent", "true");
    setCookieConsent(true);
  };

  // Make global CSS theme variables work by toggling body class
  useEffect(() => {
    // add/remove classes so index.css can switch variables
    if (darkMode) {
      document.body.classList.remove("light-mode");
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
      document.body.classList.add("light-mode");
    }
    // ensure scrollbars and other global styles re-evaluate
    return () => {};
  }, [darkMode]);

  // Background & text colors (kept for AppBar contrast only)
  const bg = theme.palette.mode === "dark" ? "#000" : "#EAEAEA";
  const fg = theme.palette.mode === "dark" ? "#FFF" : "#000";

  return (
    <>
      <AppBar
        position="fixed"
        elevation={1}
        sx={{
          height: HEADER_HEIGHT,
          backgroundColor: bg,
          color: fg,
          justifyContent: "center",
          zIndex: theme.zIndex.appBar,
        }}
      >
        <Toolbar sx={{ minHeight: HEADER_HEIGHT }}>
          {/* Left: hamburger + logo */}
          <IconButton
            edge="start"
            onClick={toggleDrawer}
            aria-label="open drawer"
            sx={{ color: fg, mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src="../xfactualLogo.png"
                alt="XFactual Logo"
                style={{ width: "125px", height: "auto" }}
              />
              <Typography variant="caption" sx={{ ml: 1 }}>
                Beta
              </Typography>
            </Box>
          </Link>

          {/* center spacer */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Right: date, account, dark-mode */}
          <Typography
            variant="body2"
            sx={{ display: { xs: "none", sm: "block" }, mr: 2 }}
          >
            {dateTime}
          </Typography>
          <IconButton aria-label="account" sx={{ color: fg, mr: 2 }}>
            <AccountCircle />
          </IconButton>
          <FormControlLabel
            control={
              <Switch checked={darkMode} onChange={toggleDarkMode} color="default" />
            }
            label="Dark Mode"
            sx={{ color: fg }}
          />
        </Toolbar>
      </AppBar>

      {/* Cookie consent banner */}
      {!cookieConsent && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            py: 1,
            px: 2,
            backgroundColor: theme.palette.mode === "dark" ? "#333" : "#f2f2f2",
            color: theme.palette.mode === "dark" ? "#fff" : "#000",
            textAlign: "center",
            zIndex: theme.zIndex.drawer,
          }}
        >
          <Typography variant="caption" sx={{ mb: 1, display: "block" }}>
            We use cookies to improve your experience. By using our site, you agree to our use of cookies.
          </Typography>
          <Button variant="contained" onClick={handleCookieConsent}>
            Accept Cookies
          </Button>
        </Box>
      )}
    </>
  );
};

export default Header;
